import { connect } from 'react-redux'
import RoundProgress from '../../components/content/round_progress'
import { setRoundStatus, toggleRoundOptions } from '../../actions/index'

// const mapStateToProps = (state) => {}

const mapDispatchToProps = (dispatch, ownProps) => ({
  setRoundStatus: (status, url, roundId, data) => dispatch(setRoundStatus(ownProps.widgetId, url, status, roundId, data)),
  toggleRoundOptions: (url, option, roundId, data) => dispatch(toggleRoundOptions(ownProps.widgetId, url, option, roundId, data)),
})

export default connect(
  null,
  mapDispatchToProps,
)(RoundProgress)
